import { useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";
import MATERIAL_TABLE_CONTAINER from "../../../../main_components/material_table/table_container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function SUBTOTAL_MISMATCH_DETAILS(props: any) {

    const columns: MRT_ColumnDef<any>[] = useMemo(
        () => [

            {
                header: "Código",
                accessorKey: "order_code",
                id: "order_code",
                size: 120,
            },
            {
                header: "Concepto",
                accessorKey: "order_product",
                id: "order_product",
                size: 300,
            },
            {
                header: "Cantidad en la Orden de Compra",
                accessorKey: "order_quantity",
                id: "order_quantity",
            },
            {
                header: "Total en la Orden de Compra",
                accessorKey: "order_total",
                id: "order_total",
            },
            {
                header: "Cantidad en la Factura",
                accessorKey: "inv_quantity",
                id: "inv_quantity",
            },
            {
                header: "Total en la Factura",
                accessorKey: "inv_total",
                id: "inv_total",
            }
        ],

        [props?.detaills]
    );



    return (
        <div>

            <MATERIAL_TABLE_CONTAINER
                key={"INVOICE_UP_LOADER_TS"}
                columns={columns}
                data={props?.detaills}
                breadcrumbs={props?.breadcrumbs ? [{ label: "ORDENES DE COMPRA DISPONIBLES", path: null }] : null}
                modalT={false}
                isLoading={false}
                search_filters={<div></div>
                }
                component_header={
                    <div></div>
                }
                file_name_export="FACTURAS"
                update_identifiers={[]}
            ></MATERIAL_TABLE_CONTAINER>

        </div >
    );
}
